import { ChangeDetectorRef, Component, OnInit, ViewChild,Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { throwError,Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuditServiceService } from '../audit-service.service';
import { DataTableDirective } from 'angular-datatables';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { DatatableService } from 'src/app/service/datatable.service';

declare var $:any;

@Component({
    selector: 'app-auditor-registration-report-component',
    templateUrl: './auditor-registration-report-component.component.html',
    styleUrls: ['./auditor-registration-report-component.component.css'],
    standalone: false
})
export class InternalAuditRegistrationReportComponent {
  tOptions: any;
  dtTrigger: Subject<any> = new Subject<any>();
  dtOptions: any;
  user: any = {};
  memCode: String;
  memId: String;
  loginId:any;
  editdata:any ={};
  auditorRegistrationPage: FormGroup;
  submitted = false;
  auditPeriod: String;
  memberCatogory: String;
  config: any;
  PeriodArray:any[]=[];
  auditorDtlsArray:any[]=[];
  education:any[]=[];
  sysAuditorDtsMessage:any;
  isEditable:boolean=true;
  NotAllowed:number=0;
  auditorAllDtls:any=[];
  filterForm:FormGroup;
  selectedRow:any=[];
  filteredData:any=[];

  
  

  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;

  public auditorDetails:any[]=[];
  constructor(
    private route: ActivatedRoute,
    private formbuilder: FormBuilder, 
    private toastr: ToastrService,
    private auditService: AuditServiceService,
    private router: Router,
    private titleService: Title,
    private cdref: ChangeDetectorRef,
    private userDetailsService:UserDetailsService,
    private dtService: DatatableService

  ) {}

  get f() { return this.auditorRegistrationPage.controls; }
  get f2() { return this.filterForm.controls; }


  reset(){
    this.auditorRegistrationPage.reset();
    this.f.loginId.setValue(null);
    this.f.loginId.enable();
    this.f.auditorMembershipNo.setValue(null);
    this.f.auditorMembershipNo.enable();
    this.f.auditorFirmName.setValue(null);
    this.f.auditorName.setValue(null);
    this.f.auditorFirmRegistrationNo.setValue(null);
    this.f.auditorQualification.setValue(null);
    this.f.auditorEmailId.setValue(null);
    this.getAllAuditorDetailsInternal( this.memId);
    this.getAllDtlsAuditor();
    this.getAvailableAuditorPriodOfInternal( this.memId);
    
  }

  getAvailableAuditorPriodOfInternal(memId:any)
  {
    this.auditService.getAvailableAuditorPriodOfInternal(memId).pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    )
    .subscribe((response:any)=>{
      this.PeriodArray=response.data.periodFromToList;
      this.auditorDtlsArray=response.data.auditorDtls;
      this.education=response.data.education;
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
      console.log( this.PeriodArray);
    
    });

   
   
    
  }

  

  ngOnInit(): void
   {
    this.user = this.userDetailsService.getUserDetails() || {};
    this.memCode=this.user.entityCode;
    this.memId = (<number>this.user.entityCode)+"";
    this.loginId = this.user.loginId;
    this.getAllAuditorDetailsInternal(this.memId);
    this.getAllDtlsAuditor();
    //this.getAllAuditorDetails(Number(this.memId));
    // this.getAvailableAuditorPriod(Number(this.memId));
   this.getAvailableAuditorPriodOfInternal(this.memId);
   this.titleService.setTitle('Auditor Registration page');
   this.auditorRegistrationPage=this.formbuilder.group({
     auditPeriod : [null,Validators.required],
     memberCatogory : [''],
     loginId: ['',Validators.required],
     auditorMembershipNo : ['',Validators.required],
     auditorFirmName: ['',Validators.required],
     auditorName : ['',Validators.required],
     auditorFirmRegistrationNo : ['',Validators.required],
     auditorQualification: ['',Validators.required],
     auditorEmailId:['',Validators.required],
     
   })

   this.filterForm=this.formbuilder.group({
    nature : ['',Validators.required],
    frmName: ['',Validators.required],
   })

   }

   newItemEvent(event: boolean){
      $('#newAuditor').modal('hide');
  }

  getAllAuditorDetailsInternal(memId:any)
   {
    this.auditService.getAllAuditorDetailsInternal(memId).subscribe((response:any)=>{
      this.auditorDetails=response.data;
      console.log( JSON.stringify(this.auditorDetails));
      this.titleService.setTitle('Auditor Registration page');
      this.auditorRegistrationPage=this.formbuilder.group({
        auditPeriod : ['',Validators.required],
        memberCatogory : ['TM'],
        loginId: ['',Validators.required],
        auditorMembershipNo : ['',[Validators.required,Validators.pattern('[0-9]*')]],
        auditorFirmName: ['',Validators.required],
        auditorName : ['',[Validators.required,Validators.pattern('[a-zA-Z][a-zA-Z ]+')]],
        auditorFirmRegistrationNo : ['',[Validators.required,Validators.pattern('^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$')]],
        auditorQualification: ['',Validators.required],
        auditorEmailId:['',[Validators.required,Validators.email]],
        
      })
      // this.setDatatable();
      this.dtService.setDatatable("auditorMis",9, 10, [10, 25, 50, 100]);

      
      });
    }

    resetEditableData(){
      this.isEditable=true;
      this.reset();
     
    }
    // creatEditobject(editdata:any)
    // {
    //   this.editdata=editdata;
    //   console.log("JSON"+JSON.stringify(this.editdata));
    // }

    
    creatEditobject(id:any)
    {
     let selectedata = this.auditorDetails.find(data=> data.auditorLoginId == id);
     console.log(selectedata);
     this.editdata=selectedata;

      this.cdref.detectChanges();
      this.f.auditPeriod.setValue(this.editdata.auditPeriod);
      
      this.f.memberCatogory.setValue('');
      this.f.memberCatogory.disable();
      this.f.loginId.setValue(this.editdata.auditorLoginId);
      this.f.loginId.disable();
      this.f. auditorMembershipNo.setValue(this.editdata.auditorMembershipNo);
      this.f.auditorFirmName.setValue(this.editdata.firmname);
      this.f.auditorName.setValue(this.editdata.audtiorName);
      this.f.auditorFirmRegistrationNo.setValue(this.editdata.auditorRegistrationNo);
      this.f.auditorQualification.setValue(this.editdata.qualitfication);
      this.f.auditorEmailId.setValue(this.editdata.emailid);
      this.isEditable=false;
    
    }
    
    removeSystemAuditPeriodMapping(memId:any,caId:any)
    {
      
      this.auditService.removeInternalAuditPeriodMappingBeforeProcess(Number(memId),caId).subscribe((response:any)=>{
        if(response.statusCode===200)
        {
          this.toastr.success(response.message);
          this.getAllAuditorDetailsInternal(memId);
        }
      })
    }
    // auditorMis

    setDatatable() {
      // $("#auditorMis").DataTable().destroy();
      setTimeout(() => {
        $("#auditorMis").DataTable({
          responsive: true,
          processing: true,
          orderCellsTop: true,
          dom: "Blrtip",
          buttons: [{
            extend: 'copy',
            titleAttr: 'Copy',
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6,7,8],
            }
          }, {
            extend: 'excel',
            titleAttr: 'Export to excel',
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6,7,8],
            }
          }, {
            extend: 'pdf',
            orientation: 'landscape',
            pageSize: 'A4',
            titleAttr: 'Download as PDF',
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6,7,8,9],
            }
          }],
          initComplete: function () {
            this.api().columns().every(function () {
              $('#auditorMis .column-search input').val('');
              $('#auditorMis .column-search select').val('.*');
              $('#auditorMis .column-search').on('keyup change', 'input', function () {
                $('#auditorMis').DataTable()
                  .column($(this).parent().index())
                  .search(this.value)
                  .draw();
              });
              $('#auditorMis .column-search').on('keyup change', 'select', function () {
                $('#auditorMis').DataTable()
                  .column($(this).parent().index())
                  .search("^" + this.value + "$", true, false, false)
                  .draw();
              });
            })
          }
        });
        this.cdref.detectChanges();
      }, 1);
    }


    getifPeriodAlreadyAssgined(reqobj:any)
    {
      this.NotAllowed=0;
      this.auditService.getifInternalPeriodAlreadyAssgined(reqobj).subscribe((response:any)=>{
        if(response.statusCode===200)
        {
          if(response.data>0)
          {
            this.toastr.warning(response.message);
          }else
          {
            this.auditService.assignedPriodToAuditorInternal(reqobj).subscribe((response:any)=>{
            if (response.statusCode == 200)
            {
              this.toastr.success(response.message);
              this.reset();
               
            }
          })
          }
        }
      })
    }

    getAllDtlsAuditor()
    {
      this.auditService.getAllDtlsAuditorInternal(this.memId).pipe(
        catchError((error: any) => {
          this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
          if (error.status != 200) {
            return throwError(error.error);
          }
        })
      ).subscribe((response:any)=>{
          if(response.statusCode==200)
          {
            this.auditorAllDtls=response.data;
            this.cdref.detectChanges();
            $('.selectpicker').selectpicker('refresh');
          }
      })
    }

    onSubmit() 
    {
     
     // this.submitted = true;

     
      let reqObj = {
  
        "period" : this.f.auditPeriod.value,
        "memberCategory" : this.f.memberCatogory.value,
        "auditorId" : this.f.loginId.value,
        "adtrMbmrNo" : this.f. auditorMembershipNo.value,
        "company_Name" : this.f.auditorFirmName.value,
        "auditor_name" : this.f.auditorName.value,
        "adtrRegNo" : this.f.auditorFirmRegistrationNo.value,
        "autrQualification" :this.f.auditorQualification.value ,
        "emailId" : this.f.auditorEmailId.value,
        "memId":  this.memId
        //"mobileNo":"12345678890"
     
      };
  
      this.getifPeriodAlreadyAssgined(reqObj)

      console.log(reqObj);
    }

    onUpdate() 
    {
     
   
      let reqObj = {
  
        "period" : this.f.auditPeriod.value,
        "memberCategory" : this.f.memberCatogory.value,
        "auditorId" : this.f.loginId.value,
        "adtrMbmrNo" : this.f. auditorMembershipNo.value,
        "company_Name" : this.f.auditorFirmName.value,
        "auditor_name" : this.f.auditorName.value,
        "adtrRegNo" : this.f.auditorFirmRegistrationNo.value,
        "autrQualification" :this.f.auditorQualification.value ,
        "emailId" : this.f.auditorEmailId.value,
        "memId":  this.memId,
        //"mobileNo":"12345678890"
     
      };
  
      this.auditService.UpdateInternalAuditorDetailsAuditor(reqObj).subscribe((response:any)=>{
        if (response.statusCode == 200)
        {
          this.toastr.success(response.message);
          this.reset();
          this.getAllAuditorDetailsInternal( this.memId);
        }
      })
      console.log(reqObj);
    }

    OnChangeOfName()
    {
         this.selectedRow= this.auditorAllDtls.find(data => data.audtiorName===this.f2.nature.value);
         this.cdref.detectChanges();
         this.f2.frmName.setValue(this.selectedRow.firmname);
         $('.selectpicker').selectpicker('refresh');
         console.log(this.selectedRow)
        
    }

    
    OnChangeOfFirm()
    {
        let selectedRow= this.auditorAllDtls.find(data => data.firmname===this.f2.frmName.value);
         this.cdref.detectChanges();
         this.f2.nature.setValue(selectedRow.audtiorName);
         $('.selectpicker').selectpicker('refresh');  
    }

        
    filter()
    {
        this.filteredData=[];
        this.filteredData=this.auditorDetails.find(data=> data.audtiorName === this.f2.nature.value);
       
        if(this.filteredData!=null)
          {
            this.auditorDetails=[];
            this.auditorDetails=this.filteredData;
            $('.selectpicker').selectpicker('refresh');  
            this.cdref.detectChanges();
  
          }
          else
          {
            this.toastr.info("No Data Found For Given Criteria");
          }

        

    }

    resetDetails()
    {
      this.getAllAuditorDetailsInternal( this.memId);
    }


    isConssecutiveSubmisstion()
    {
      this.auditService.isConssecutiveSubmisstionInternal(Number( this.memId),this.f.loginId.value).pipe(
        catchError((error: any) => {
          this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
          if (error.status != 200) {
            return throwError(error.error);
          }
        })
      ).subscribe((res:any)=>{
         if(res.statusCode==200) 
          {
              if(res.data==true)
                {
                  this.toastr.warning("Auditor has consecutive Submission");
                  this.f.auditorMembershipNo.disable();
                  this.f.auditorFirmName.disable();
                  this.f.auditorName.disable();
                  this.f.auditorFirmRegistrationNo.disable();
                  this.f.auditorQualification.disable();
                  this.f.auditorEmailId.disable();
                }
         
          }
      })
    }
}
